import { useFeatureFlagEnabled } from "@posthog/react";
import { createContext, ReactNode, useContext, useMemo } from "react";

export interface ChatEntityFeatureFlags {
  isMomentsEnabled: boolean;
  isSwapsEnabled: boolean;
}

const defaultFlags: ChatEntityFeatureFlags = {
  isMomentsEnabled: false,
  isSwapsEnabled: false,
};

const ChatEntityFeatureFlagsContext =
  createContext<ChatEntityFeatureFlags>(defaultFlags);

export function ChatEntityFeatureFlagsProvider({
  children,
}: {
  children: ReactNode;
}) {
  const isMomentsFlag = useFeatureFlagEnabled("enable-moments");
  const isSwapsFlag = useFeatureFlagEnabled("enable-swaps");

  const value = useMemo(
    () => ({
      isMomentsEnabled: isMomentsFlag === true,
      isSwapsEnabled: isSwapsFlag === true,
    }),
    [isMomentsFlag, isSwapsFlag],
  );

  return (
    <ChatEntityFeatureFlagsContext.Provider value={value}>
      {children}
    </ChatEntityFeatureFlagsContext.Provider>
  );
}

export function useChatEntityFeatureFlags() {
  return useContext(ChatEntityFeatureFlagsContext);
}
